'use strict';

import $ from 'jquery';
import { onPageLoad } from '@/js/modules/page_load';
import '@/js/modules/jquery_modal_defaults';

onPageLoad(() => {
  $(function () {
    $('.clients-csv-file-upload').fileupload({
      url: '/clients/xhr_import_clients_csv',
      singleFileUploads: true,
      done(e, data) {
        $(data.result).appendTo('body').modal();
      },
      fail(_, data) {
        alert(data.jqXHR.responseJSON.error);
      },
    });

    $('.vendors-csv-file-upload').fileupload({
      url: '/vendors/xhr_import_csv',
      singleFileUploads: true,
      done(e, data) {
        $(data.result).appendTo('body').modal();
      },
      fail(_, data) {
        alert(data.jqXHR.responseJSON.error);
      },
    });
  });
});
